import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import api from '../../actions/api';

import { clearAllData } from '../../actions';
import { FiLogOut, FiUserPlus, FiChevronDown, GiTeamDowngrade, FiUsers, FiUnlock, FiInfo, FiImage, FaBath, FiSettings, FiFileText, MdOutlineAttachEmail, FiMessageSquare, FiHome } from '../../components/Icons';
import Link from '../../components/Link';


const Title = ({ title = '' }) => {
	return (
		<div className="p-2 pl-10">
			<span className="text-white text-base font-bold">{title}</span>
		</div>
	);
};


export default function MenuItem(props) {
	const { type, closeMenu = () => null } = props;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { data } = useSelector(state => state.storage)
	let id = '';

	if (data.id) {
		id = data.id
	} else if (get(data, 'id', '')) {
		id = get(data, 'id', '')
	}

	const [activesubmenu, setactivesubmenu] = useState(false);
	const [activekey, setactivekey] = useState(-1);
	const NavItem = ({ onClick = '', icon = '', link = '', label = '', pl = 'pl-8', blc = 'border-l-secondary', sub_menu, index }) => {
		return (
			<NavLink
				onClick={onClick}
				className={({ isActive }) =>
					'h-14 bg-secondary flex row cursor-pointer items-center border-l-8 ' +
					blc +
					' hover:border-l-primary transition duration-500' +
					(isActive ? ' !border-l-primary' : '')}
				to={link}>
				<div className={`flex ${pl} text-white row items-center text-base`}>
					{icon}
					<span className="pl-4">{label}</span>
				</div>
				{
					sub_menu && <div className={`absolute top-5 right-6 text-white`}>
						<FiChevronDown className={`${activekey === index ? `rotate-180` : `rotate-0`} transform-gpu `} />
					</div>
				}
			</NavLink>
		);
	};

	const adminList = [
		{ link: '/account', label: 'Users', icon: <FiUsers /> },
		{ link: '/media', label: 'Media', icon: <FiImage /> },
		{ link: '/activity', label: 'Activity', icon: <FiInfo /> },
		{ link: '/deviceactivity', label: 'Device Activity', icon: <FiInfo /> },
		{ link: `/password/${id}`, label: 'Change Password', icon: <FiUnlock /> },
		{ link: '/cronlog', label: 'Cron', icon: <FiInfo /> },
	];
	const changemenu = (val, key, closemenu) => {
		setactivesubmenu(val);
		setactivekey(key);
		if (closemenu) {
			closeMenu();
		}
	};
	let pageList = [
		{
			link: '/userapp',
			label: 'App Users',
			icon: <GiTeamDowngrade />,
		},
		{
			link: '/monkdevice',
			label: 'Monk Device',
			icon: <FaBath />,
		},
		{
			link: '/firmware',
			label: 'Firmware',
			icon: <FaBath />,
		},
		{
			link: '/programme',
			label: 'Programmes',
			icon: <FaBath />,
		},
		{
			link: '/dropinsession',
			label: 'Drop in sessions',
			icon: <FaBath />,
		},
		{
			link: '/education',
			label: 'Education',
			icon: <FiFileText />,
		},
		{
			link: '/emailcontent',
			label: 'Email Content',
			icon: <MdOutlineAttachEmail />,
		},
		{
			link: '/errorcontent',
			label: 'Error Content',
			icon: <FiMessageSquare />,
		},
		{
			link: '/settings',
			label: 'App Settings',
			icon: <FiSettings />,
		},
		{
			link: '/devicedefault',
			label: 'Device Default',
			icon: <FiSettings />,
		},
		{
			link: '/home',
			label: 'Home',
			icon: <FiHome />,
		},
		{
			link: '/contact',
			label: 'Contact',
			icon: <FiUserPlus />,
		}
	];

	const logout = () => {
		// dispatch(clearAllData())
		// navigate('/');
		api.post('/logout').then((res) => {
			if (res.status === 200) {
				dispatch(clearAllData());
				navigate('/');
			}
		});
	}
	return (
		<div>
			<ul className="pb-6 bg-secondary overflow-visible">
				{pageList.map((item, i) => {
					let submenu = get(item, 'sub_menu', []);
					return (
						<div key={`menu_list_${i}`}>
							<li className={`relative group`} key={`menu_list_${i}`}>
								<NavItem onClick={() => { changemenu(true, activekey === i ? false : i, submenu.length === 0 ? true : false) }} {...item} type={type} index={i} />
								{submenu.length > 0 && (
									<ul className={`bg-[#1e293b] transition-all group-hover:visible ${activesubmenu && activekey === i ? 'relative' : ' absolute z-[999] top-0 left-full w-full h-fit invisible'}`} id={`sub_menu_p${i}`}>
										<NavItem onClick={() => { changemenu(true, i, true); }} link={item.link} label={`All ${item.label}`} type={type} index={i} pl={`${activesubmenu ? 'pl-12' : 'pl-5'}`} blc="border-l-shade" />
										{submenu.map((sub_item, sub_i) => {
											return (
												<li id={`sub_menu_p${sub_i}`} key={`sub_menu_${sub_i}`}>
													<NavItem onClick={() => { changemenu(true, i, true); }} index={i} type={type} {...sub_item} pl={`${activesubmenu ? 'pl-12' : 'pl-5'}`} blc="border-l-shade" />
												</li>
											);
										})}
									</ul>
								)}
							</li>
						</div>
					);
				})}
				<li>
					<Link
						to={`${process.env.REACT_APP_URL}/docs`}
						target="_blank"
						className="h-14 bg-secondary flex row cursor-pointer items-center border-l-8 border-l-secondary hover:border-l-primary transition duration-500">
						<div className="flex pl-8 text-white row items-center text-base" >
							<FiFileText />
							<span className="pl-4">API Docs</span>
						</div>
					</Link>
				</li>
			</ul>
			<ul className="py-6 border-t border-t-white bg-secondary">
				{
					<>
						<Title title={'Admin'} />
						{
							adminList.map((item, ind) => (
								<li key={`admin_list_${ind}`} id={`admin_list_${ind}`}>
									<NavItem {...item} type={type} index={ind} onClick={closeMenu} />
								</li>
							))
						}
					</>
				}
				<li>
					<Link
						onClick={logout}
						className="h-14 bg-secondary flex row cursor-pointer items-center border-l-8 border-l-secondary hover:border-l-primary transition duration-500">
						<div className="flex pl-8 text-white row items-center text-base" >
							<FiLogOut />
							<span className="pl-4">Logout</span>
						</div>
					</Link>
				</li>
			</ul>
		</div>
	);
}
